import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionPlanService } from '@services/subscription-plan';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useDeleteSubscriptionPlan = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['subscriptionPlans', 'delete'],
    mutationFn: async (planId: string) => {
      return await subscriptionPlanService.delete(planId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscriptionPlans'] });
      toast.success(tActionMessages.subscriptionPlanDeletedSuccessfully);
    },
    onError: (error: any) => {
      console.error('Delete subscription plan error:', error);
      // The server message is shown verbatim (e.g. the refusal naming the plan and the count of
      // subscriptions still using it); no client-side rewording.
      toast.error(error?.response?.errors?.[0]?.message ?? 'Failed to delete subscription plan');
    },
  });
};
